import { render, staticRenderFns } from "./erOption.vue?vue&type=template&id=a0ebbdaa&"
import script from "./erOption.vue?vue&type=script&lang=js&"
export * from "./erOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports